import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Dropdown, MenuItem } from 'react-bootstrap'

class ConvertButton extends Component {
  constructor(props) {
    super(props)
    this.state = { ids: [] }
    this.handleOnSelect = this.handleOnSelect.bind(this)
    this.crossrefs = {
      FBab: [     'al','ba',                                   'rf',     'st',     'ti',     'tp'],
      FBal: ['ab',     'ba',          'co','gn',               'rf','sf','st',     'ti','to','tp'],
      FBba: ['ab','al',                                        'rf',    ,'st',     'ti'],
      FBcl: [                              'gn',     'lc',                                   'tp','tr'],
      FBch: [                                                  'rf'],
      FBco: [     'al',                                        'rf',     'st'],
      FBgn: [     'al',          'cl',          'hh',     'pp','rf','sf','st',     'ti',          'tr'],
      FBhh: [                              'gn',               'rf'],
      FBpp: [                              'gn',               'rf',                              'tr'],
      FBrf: ['ab','al','ba','ch','cl',     'gn','hh',     'pp',               'te','ti',     'tp','tr'],
      FBsf: [     'al',                    'gn',     'lc',                         'ti',     'tp'],
      FBst: ['ab','al','ba',          'co','gn',                                   'ti'],
      FBtc: [                                                                      'ti',     'tp'],
      FBte: [                              'gn',               'rf',               'ti'],
      FBti: ['ab','al','ba',               'gn',               'rf','sf','st','te',     'to','tp'],
      FBto: [     'al',                    'gn',                                             'tp'],
      FBtp: ['ab','al',          'cl',                         'rf','sf',          'ti','to'],
      FBtr: [                    'cl',     'gn',          'pp','rf'],
    }
  }

  handleOnSelect(key) {
    this.setState(
      (prevState, props) => {
        return {
          ids: props.ids,
        }
      },
      () => {
        this.convertForm.convert.setAttribute('value', key)
        this.convertForm.submit()
      }
    )
  }

  menuItems(DCs, dataClassLabels) {
    let data_type = DCs.length === 1 ? DCs[0] : null
    let valids = this.crossrefs[data_type]
    let itms = [
      <MenuItem
        key="header"
        header
        style={{ fontStyle: 'italic', color: 'steelblue' }}>
        selected items to:
      </MenuItem>,
    ]
    if (valids) {
      valids.forEach(function (sfx) {
        let eKey = 'FB' + sfx
        if (dataClassLabels[eKey]) {
          let label = dataClassLabels[eKey]
          label =
            label.substr(-1, 1) === 'y'
              ? label.slice(0, label.length - 1) + 'ies'
              : label + 's'
          itms.push(
            <MenuItem key={eKey} eventKey={eKey}>
              {label}
            </MenuItem>
          )
        }
      })
    }
    return <Dropdown.Menu bsClass="primary">{itms}</Dropdown.Menu>
  }

  render() {
    let dsbld =
      this.props.dataClasses.length > 1 ||
      !this.crossrefs.hasOwnProperty(this.props.dataClasses[0])
        ? true
        : false
    let title = ''
    if (
      this.props.dataClasses.length > 0 &&
      !this.crossrefs.hasOwnProperty(this.props.dataClasses[0])
    ) {
      let dcName = this.props.dataClassLabels[this.props.dataClasses[0]]
      dcName =
        dcName.substr(-1, 1) === 'y'
          ? dcName.slice(0, dcName.length - 1) + 'ies'
          : dcName + 's'
      /* prepended spaces on these titles moves the text out from under the large 'disabled' pointer */
      title = '      No conversions available for ' + dcName
    }
    if (this.props.dataClasses.length > 1)
      title = '      Conversion only available for single data class (filtered) lists'

    /* Only update the form DOM when the state changes, not the props. */
    /*  Generate hidden input fields from the IDs in state.
            If you do this directly from the props, there is a noticeable
            lag in the UI when a user switches between tabs.
            This approach that uses props and state eliminates that. */
    const { ids } = this.state
    const idInputs = ids.map((id, i) => (
      <input type="hidden" key={id + i} name="ids" value={id} readOnly />
    ))

    /* values for hidden params 'ids' and 'convert' will be set by handleOnSelect */
    return (
      <Dropdown
        id="hitlist-conversion"
        onSelect={this.handleOnSelect}
        disabled={dsbld}
        title={title}>
        <Dropdown.Toggle bsStyle="primary">Convert</Dropdown.Toggle>
        {this.menuItems(this.props.dataClasses, this.props.dataClassLabels)}
        <form
          method="post"
          action="/cgi-bin/export2batch.pl"
          ref={(form) => (this.convertForm = form)}>
          <input type="hidden" key="mode" name="mode" value="convert" />
          <input type="hidden" key="convert" name="convert" value="" />
          <input type="hidden" key="caller" name="caller" value="hitlist" />
          {idInputs}
        </form>
      </Dropdown>
    )
  }
}

ConvertButton.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.string),
}

ConvertButton.defaultProps = {
  ids: [],
}

export default ConvertButton
